// BHP-1062: generic VPS detail on Backend2.0.
//
// The route carries our uuid, not the Hetzner id. That was the bug: since the
// overviews moved to Backend2.0 (BHP-1087/1088/1089) they linked with a uuid,
// while this page still did `Number(serverId)` and redirected back to the
// overview when that came out NaN — so clicking a server did nothing.
import { useParams } from 'react-router-dom';
import VpsServerDetail from '../../features/vps/ui/VpsServerDetail';

export default function VpsDetails(): JSX.Element {
  const { uuid } = useParams<{ uuid: string }>();

  return (
    <VpsServerDetail
      uuid={uuid ?? ''}
      overviewPath="/vps/generic/overview"
      overviewLabel="Back to servers"
    />
  );
}
